export const PATH = {
  SUSPICIOUS_TRAFFIC: 'suspicious-traffic',
  ROUTING_STATUS: 'routing-status',
  ALERTS_SUSPICIOUS_TRAFFIC: 'alerts-suspicious-traffic',
  ALERTS_ROUTING_STATUS: 'alerts-routing-status',
  REQUEST_INSIGHTS_OF_SUSPICIOUS_TRAFFIC: 'what-to-do',
  OTHERS: 'others'
};

export const SELECTED_COMBO_BOX_TYPE = {
  MEMBER_ACCOUNT: 'member_account',
  ASN_CONTEXT: 'asn_context',
  NONE: 'none'
};

export const SPINNER_TYPE = {
  FETCHING_ALERT: 'fetching_alert',
  CREATING_ALERT: 'creating_alert',
  DELETING_ALERT: 'deleting_alert',
  EDITING_ALERT: 'editing_alert',
  SNOOZING_ALERT: 'snoozing_alert',
  UN_SNOOZING_ALERT: 'un_snoozing_alert'
};

export const MAX_QUERY_HISTORY_ENTRIES_APNIC_STAFF = 10;

export const LOCAL_STORAGE_ITEM_LIST = {
  MEMBER_ACCOUNT_QUERY_HISTORY: 'member_account_query_history'
};
